<section class="flex items-center pt-8">
  <span [routerLink]="RouterLink" role="button" class="btn-gradient-bg p-3 ">
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 41 39">
      <path fill="#fff"
        d="M0 19.5 19.02.5v12.244C26.348 12.744 41 17.896 41 38.5c0-11.147-14.653-13.37-21.98-13.089V38.5L0 19.5Z" />
    </svg>
  </span>

  <h2 class="w-full text-end md:text-center relative heading-m md:heading-l text-clip-bg" [attr.data-text]="title">{{title}}</h2>

</section>